export const computePhaseProgress = (roadmaps, submissions) => {
  const submittedIds = new Set(submissions.map((s) => s.checkpointId));
  return roadmaps.map((phase) => {
    const checkpoints = phase.checkpoints || [];
    const total = checkpoints.length;
    const completed = checkpoints.filter((cp) =>
      submittedIds.has(cp.checkpointId)
    ).length;
    const percent = total > 0 ? Math.round((completed / total) * 100) : 0;
    return { ...phase, progress: { percent } };
  });
};
